/**
* @copyright Copyright (C) 2020 Kokoon - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*/

import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/core/styles';
import KnNotificationBar from 'components/NotificationBar';
import KnHeader from './Header';
import withAppInsights from '../appInsights';

const Main = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: '100vh',
});

const Content = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
});

const KnLayout = ({ children }) => (
  <Main data-testid="kn-main-container">
    {/** Common header (logo and navigation) for all pages */}
    <KnHeader />
    {/** Request loading indicator and error message: */}
    <KnNotificationBar />
    {/** Page content */}
    <Content data-testid="kn-content-container">
      {children}
    </Content>
  </Main>
);

KnLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withAppInsights(KnLayout);
